import { IModalContentService } from 'common/contracts';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from 'store/store';

const PrimaryModal = ({ modalService }: { modalService: IModalContentService }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();

  const { modalReducer } = useSelector((state: RootState) => state);

  return <></>;
};

export default PrimaryModal;
